import lang from 'quasar/lang/en-US'
import '@quasar/extras/material-icons/material-icons.css'
import { Notify, Dialog } from 'quasar'

Notify.setDefaults({
    html: true,
    group: false,
})

export default {
    config: {
        dark: false,
        animations: 'all',
    },
    animations: 'all',

    plugins: {
        Notify,
        Dialog,
    },
    lang,
}

